import Agent, {
  type AgentInstances,
  type AgentParams,
  type AgentSuggestions,
} from './Agent';

// Default agent that is used when no other agent is specified. Provides
// generic LLM functionality with Aha! tools.
class DefaultAgent extends Agent {
  static name = 'DefaultAgent';

  static publicName = 'Universal';

  static available(
    _agentParams: AgentParams,
    _agentInstances: AgentInstances
  ): boolean {
    return window.currentAccount?.hasGeneralAiAssistant || false;
  }

  getSuggestions(): AgentSuggestions {
    return [
      {
        title: 'Create',
        prompt: 'Tell me what type of Aha! record you want to create.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to create an Aha! record.\n\nLet's start...\n\nThe record is: `,
        icon: 'whiteboard',
      },
      {
        title: 'Draft',
        prompt:
          'Tell me what you are writing and share some details about what to include and the tone. You can add example text and even refer to existing Aha! records by their ID.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to draft a document.\n\nBefore starting though determine if I have told you how long I want the document. If not, ask me.\nLet's start...\n\nThe document is: `,
        icon: 'draft',
      },
      {
        title: 'Report',
        prompt:
          'Tell me what you want to report on. You can specify the details of the report. For example, you can ask to view a list report of "features with new activity" or "features assigned to me."',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to create or modify a report.\n\nLet's start...\n\nThe report is: `,
        icon: 'list',
      },
    ];
  }
}
Agent.register(DefaultAgent);
